import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

const TESTID = 'icon-close-framed';
/**
 * TODO:The Icon Library's Close (Colors--Icons---Illustrations-Design-System node 735-2901, state=on) exported with
 * its 24px frame, so the glyph keeps Figma's padding at any size. `close` is the bare vector its legacy callers
 * are sized around; consolidating the two will be done in a future PR
 */
export const CloseFramedIcon = ({ fill = 'black', size = 'xsmall', className }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill, className);
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            data-testid={TESTID}
        >
            <path
                className={fillStyles}
                d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z"
            />
        </svg>
    );
};
CloseFramedIcon.TEST_ID = TESTID;
